/* global $ */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "checkbox",
    "actionBar",
    "count",
    "selectAll",
    "targetList",
  ];
  static values = {
    bulkDestroyUrl: String,
    bulkMoveUrl: String,
  };

  connect() {
    this.updateState();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => (cb.checked = checked));
    this.updateState();
  }

  toggle() {
    this.updateState();
  }

  updateState() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    const count = checked.length;

    if (this.hasActionBarTarget) {
      this.actionBarTarget.style.display = count > 0 ? "" : "none";
    }
    if (this.hasCountTarget) {
      this.countTarget.textContent = count;
    }
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked =
        count > 0 && count === this.checkboxTargets.length;
    }
  }

  selectedIds() {
    return this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.value);
  }

  buildForm(action, method) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = action;

    const csrfMeta = document.querySelector('meta[name="csrf-token"]');
    if (csrfMeta) {
      const tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "authenticity_token";
      tokenInput.value = csrfMeta.content;
      form.appendChild(tokenInput);
    }

    if (method !== "POST") {
      const methodInput = document.createElement("input");
      methodInput.type = "hidden";
      methodInput.name = "_method";
      methodInput.value = method;
      form.appendChild(methodInput);
    }

    return form;
  }

  bulkRemove(event) {
    event.preventDefault();
    const ids = this.selectedIds();
    if (ids.length === 0) return;

    const form = this.buildForm(this.bulkDestroyUrlValue, "DELETE");
    ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "membership_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  bulkMove(event) {
    event.preventDefault();
    const ids = this.selectedIds();
    if (ids.length === 0) return;

    const targetListId = this.hasTargetListTarget
      ? this.targetListTarget.value
      : null;
    if (!targetListId) return;

    const form = this.buildForm(this.bulkMoveUrlValue, "POST");
    ids.forEach((id) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "membership_ids[]";
      input.value = id;
      form.appendChild(input);
    });

    const targetInput = document.createElement("input");
    targetInput.type = "hidden";
    targetInput.name = "target_list_id";
    targetInput.value = targetListId;
    form.appendChild(targetInput);

    document.body.appendChild(form);
    form.submit();
  }
}
